function traverse(folder, file, parentId) {
  const childrenFolder = folder.filter(each => each.parent === parentId);
  const childrenFile = file.filter(each => Number(each.folderID) === parentId);
  childrenFolder.forEach(child => {
    child.children = traverse(folder, file, Number(child.folderID));
  });
  return [...childrenFolder, ...childrenFile];
}

function tree(folder, file) {
  const rootFile = file.filter(node => !Number(node.folderID));
  const rootFolders = folder.filter(node => !node.parent).map(each => {
    each.children = traverse(folder, file, Number(each.folderID));
    return each;
  });
  return [...rootFolders, ...rootFile]
}

export default tree;
